export const OWL_INTEGER_DIGIT_WIDTH = 7;
export const OWL_INTEGER_COMMA_WIDTH = 3;
export const OWL_INTEGER_GROUP_SIZE = 3;
export const OWL_INTEGER_GLYPH_HEIGHT = 12;
/** Left edge of a fixed digit slot, counting digits from the right. */
export function owlIntegerDigitSlotLeft(endX, indexFromRight) {
    const commasToRight = Math.floor(indexFromRight / OWL_INTEGER_GROUP_SIZE);
    return endX
        - (indexFromRight + 1) * OWL_INTEGER_DIGIT_WIDTH
        - commasToRight * OWL_INTEGER_COMMA_WIDTH;
}
export function owlRightAlignedSlotCapacity(width) {
    let count = 0;
    while (owlIntegerDigitSlotLeft(width, count) >= 0)
        count++;
    return count;
}
export function owlLeftAlignedSlotCapacity(width) {
    return Math.floor(width / OWL_INTEGER_DIGIT_WIDTH);
}
//# sourceMappingURL=integer-slot-geometry.js.map